<style scoped>
    .login-layout {
        background-color: #333333;
    }
</style>

<template>
    <v-app>
        <v-main style="overflow:hidden;position:relative;" id="main" class="login-layout">
            <router-view></router-view>
            <app-snackbar></app-snackbar>
            <app-dialog v-model="dialog.show" :config="dialog.config"></app-dialog>
        </v-main>
        <app-bottom-sheet></app-bottom-sheet>
    </v-app>
</template>

<script>
import appBottomSheet from "../../app/components/app.bottom.sheet.vue";
import appDialog from "../../app/components/app.dialog.vue";
import appSnackbar from "../../app/components/app.snackbar.vue";

import events from "../../app/app.events";

export default { 
    data: function () {
        return {
            dialog: {
                show: false,
                config: {
                    onConfirm: null,
                    onCancel: null
                }
            },            
        }
    },
    mounted: function () {
    },
    created: function () {
        this.$bus.handle(events.APP_DIALOG_OPEN, this.dialogOpen.bind(this));
    },
    computed: {
    },
    methods: {
        dialogOpen(config) {
            this.$set(this.dialog, "config", config);
            this.dialog.show = true;
        }        
    },
    components: {
        appBottomSheet,
        appDialog,
        appSnackbar        
    }
}
</script>